export default "__VITE_ASSET__aHPTqBNN__"